declare const window: Window & { dataLayer?: any[] }

function getAxonEventId(): string {
  const regex = /[?&]utm_content=([^&#]*)/i
  const result = regex.exec(window.location.href)
  return result ? decodeURIComponent(result[1]) : ''
}

export function pushAxonEvent(eventName: string, params: Record<string, any>) {
  window.dataLayer = window.dataLayer || []

  if (params.items !== undefined)
    window.dataLayer.push({ items: null })
  window.dataLayer.push({ event: eventName, event_id: getAxonEventId(), ...params })
}

export function buildAxonItem(productId: string | number, productName: string, price: string | number) {
  return {
    item_id: String(productId),
    item_name: productName,
    price: Number(price),
    quantity: 1,
  }
}
